export default __webpack_public_path__ + "static/media/molten_thumb.691bd818.jpg";